import { defineStore } from 'pinia';
import { moduleStateStorage } from '@/storages/browser.storage';
import { ModuleStateStore } from '@/entities/moduleState.entity';
import { MODULES } from '@/app-constants/module.constants';

export const useModuleStateStore = defineStore('module-state-store', {
  state: (): ModuleStateStore => {
    const defaultState = {} as ModuleStateStore;

    Object.values(MODULES).forEach((moduleObj) => {
      const name = moduleObj.moduleName;
      defaultState[name] = {
        selectedTenants: [],
      };
    });

    return moduleStateStorage.get() ?? defaultState;
  },

  actions: {
    getTenantSelections(): string[] {
      return this[MODULES.HOME.moduleName]?.selectedTenants ?? [];
    },

    getTenantSelection() {
      return this[MODULES.HOME.moduleName]?.selectedTenant ?? null;
    },

    keepTenantSelection(tenant: string) {
      this[MODULES.HOME.moduleName].selectedTenant = tenant;
      moduleStateStorage.set(this.$state as ModuleStateStore);
    },

    keepTenantSelections(tenants: string[]) {
      this[MODULES.HOME.moduleName].selectedTenants = tenants;
      moduleStateStorage.set(this.$state as ModuleStateStore);
    },

    getFilterMode(): 'accounts' | 'tags' {
      return this[MODULES.HOME.moduleName]?.filterMode ?? 'accounts';
    },

    keepFilterMode(mode: 'accounts' | 'tags') {
      this[MODULES.HOME.moduleName].filterMode = mode;
      moduleStateStorage.set(this.$state as ModuleStateStore);
    },

    getTagSelections(): string[] {
      return this[MODULES.HOME.moduleName]?.selectedTags ?? [];
    },

    keepTagSelections(tags: string[]) {
      this[MODULES.HOME.moduleName].selectedTags = tags;
      moduleStateStorage.set(this.$state as ModuleStateStore);
    },

    getSelectAllAccounts(): boolean {
      return this[MODULES.HOME.moduleName]?.selectAllAccounts ?? false;
    },

    keepSelectAllAccounts(selectAll: boolean) {
      this[MODULES.HOME.moduleName].selectAllAccounts = selectAll;
      moduleStateStorage.set(this.$state as ModuleStateStore);
    },

    resetModuleStateStore() {
      Object.values(MODULES).forEach((moduleObj) => {
        this[moduleObj.moduleName].selectedTenants = [];
        this[moduleObj.moduleName].selectedTenant = null;
        this[moduleObj.moduleName].filterMode = 'accounts';
        this[moduleObj.moduleName].selectedTags = [];
        this[moduleObj.moduleName].selectAllAccounts = false;
      });
      // Remove entirely from session storage (or store the empty state):
      moduleStateStorage.remove();
    },
  },
});
